import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import RequireIcon from "@/assets/svg/require.svg?react";

import { cn } from "@core/utils/domUtil";

interface ILabelProps extends React.ComponentProps<typeof LabelPrimitive.Root> {
  children?: React.ReactNode;
  required?: boolean;
}

function Label({ className, children, required = false, ...props }: ILabelProps) {
  return (
    <LabelPrimitive.Root data-slot="label" className={cn("flex items-center gap-[6px] text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 lg:gap-2", className)} {...props}>
      {required && <RequireIcon />}
      {children}
    </LabelPrimitive.Root>
  );
}

export { Label };
